export default __webpack_public_path__ + "static/media/sun.d21996f8.svg";